document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.remove('page-out');
    document.body.classList.remove('page-out-left');
    document.body.classList.remove('page-out-right');

    const fPageLoad = (href: any, bodyClass: any) => {
        document.body.classList.add(bodyClass);
        window.location.href = href;
        setTimeout(() => {
            // remove bug on ios, when page back-swipe
            document.body.classList.remove(bodyClass);
        }, 300);
    };

    const links = document.querySelectorAll(
        '.header__link,.header__user__link,.fmenu__link'
    );
    links.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const href = link.getAttribute('href');
            fPageLoad(href, 'page-out');
        });
    });

    const linksSlide = document.querySelectorAll('.menu__link,.menu-user');
    linksSlide.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const href = link.getAttribute('href');
            localStorage.setItem('pageLoad', 'left');
            fPageLoad(href, 'page-out-left');
        });
    });

    const linksBack = document.querySelectorAll('.h1-back-link');
    linksBack.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const href = link.getAttribute('href');
            localStorage.setItem('pageLoad', 'right');
            fPageLoad(href, 'page-out-right');
        });
    });
});
